<style lang="scss" scoped>

    #sidebar{
        width: 400px;
        position: fixed;
        top: 0;
        right: 0;
        height: 100vh;
        z-index: 999;
        color: rgba(0,0,0,.5);
        transition: all .3s;
        border:0;
        color:#ffffff;
        z-index:1000;
        display:flex;
        flex-direction: column;
        //overflow: hidden;
        right: -130%;
        transition: all 600ms;
        font-family: "miller-banner", serif;
        color: #151515;

        .left-for-free-shipping{
            border: 1px solid #b6975c;
            background: #f7f4f0;
            color: #b6975c;
            font-weight: 600;
        }

        .content{
            z-index:10;
            background: #f1ece5;
        }

        .background-obfuscator{
            position:fixed;
            left:0px;
            top:0;
            width: calc(100%);
            height:100%;
            background:rgba(0, 0, 0, 0.5);
            z-index:-1;
            opacity: 0;
            transition: all 600ms;
            pointer-events: none;
        }

        &.appear{
            right:0;
            transition: all 600ms;

            .background-obfuscator{
                pointer-events: all;
                opacity:1;
                transition: all 600ms;
            }

        }

        span.price{
            color: #C0A680;
            display: inline-block;
            margin-left: auto;
        }

        .p-img{
            position: relative;
            //max-width: 56px;
            max-width: 42px;
            width: 100%;
            object-fit: contain;
            //left:-15px;
        }

        .product-line{
            margin-bottom: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid rgb(224 213 197);

            &:last-child{
                border:0;
            }

        }

        .free-shipping{
            position: relative;
            width: 100%;

            &:before{
                content:"";
                position: absolute;
                left: -40px;
                top: 0;
                width: calc(100% + 80px);
                height:1px;
                background: rgba(255, 255, 255, 0.5);
            }

            &:after{
                content:"";
                position: absolute;
                left: -40px;
                bottom: 0;
                width: calc(100% + 80px);
                height:1px;
                background: rgba(255, 255, 255, 0.5);
            }


        }

        .close-preview{
            position:absolute;
            right: 25px;
            top: 27px;
            width:30px;
            height:30px;
            display:flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 200ms;
            -webkit-filter: brightness(0);
            filter: brightness(0);

            &:hover{
                transition: all 200ms;
                filter: brightness(100%);
            }

            @media (max-width: 1599px) and (min-width: 1399px) {
                -webkit-transform: scale(0.95);
                transform: scale(0.95);
            }

        }

        .totale{
            border-top: 1px solid #e0d5c5;
            border-bottom: 1px solid #e0d5c5;
        }

    }

</style>

<template>
    <nav id="sidebar" class="collapse show" :class="show ? 'appear' : ''">
        <div class="h-100 p-4 content">
            <div class="h-100 px-3">
                <div class="d-flex flex-column h-100 px-0 mt-0">
                    <div class="close-preview" @click="show = false">
                        <img width="26" src="/images/svg/roeno-43.svg" alt="chiudi"/>
                    </div>
                    <div class="flex-grow-1 overflow-auto">
                        <div class="text-left mt-2 mb-5"><p>{{$root.translateString('products_in_total')}}:&nbsp; <span>({{countProducts}})</span></p></div>
                        <div class="all-list">
                            <div class="w-100 d-flex product-line align-items-start" v-for="(item, key) in cart" :key="key">
                                <img width="70" class="p-img object-fit-contain mt-1" :src="item.options.image" :alt="item.options.name" />
                                <div class="d-flex flex-column flex-grow-1 pl-4">
                                    <div class="d-flex flex-grow-1 pl-0 pt-0 w-100">
                                        <span class="pr-2 h-100 text-nowrap">{{item.qty}} x</span>
                                        <span class="flex-grow-1 d-flex flex-column">
                                            <span class="text-uppercase" v-text="item.options.name.replace('<br>', ' ')"></span>
                                            <span class="w-100 text-gold" v-if="item.options.type == 'vini'" v-text="item.options.combination"></span>
                                            <span class="w-100 text-gold" v-else-if="item.options.type == 'visite' || item.options.type == 'eventi'">
                                                {{parseInt(item.options.visit.adults) + parseInt(item.options.visit.kids)}}
                                                <span v-if="item.options.visit.adults==1">{{$root.translateString('person')}}</span>
                                                <span v-else>{{$root.translateString('people')}}</span>
                                                <span v-if="item.options.combination && item.options.type != 'eventi'">
                                                    -
                                                {{ translateVisitOptional(item.options.combination.replace(" ", "")) }}

                                                </span>
                                            </span>
                                            <span class="w-100 text-gold" v-else-if="item.options.type == 'gift-card'">
                                                <span v-if="lang == 'it'">
                                                    Valore {{item.options.price}}€
                                                </span>
                                                <span v-else>
                                                    {{item.options.price}}€ Value
                                                </span>
                                            </span>
                                            <span class="w-100 text-gold" v-else>Cantina Roeno</span>
                                        </span>
                                    </div>
                                    <div class="py-0 d-flex flex-grow-1 mt-2 pl-0">
                                        <p class="flex-grow-1 price">
                                            € {{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}
                                        </p>
                                        <div class="carrello-item__remove-btn">
                                            <a href="javascript:void(0)" @click="updateCart(key, 0)">
                                                <img src="/images/svg/as-1.svg" alt="icona" />
                                                <span>{{$root.translateString('remove')}}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="free-shipping py-2 mb-4 d-none">
                        <div class="">
                            <p class="mb-0 py-1">{{$root.translateString('free_shipping')}} <span>€ 120</span></p>
                        </div>
                    </div>

                    <p class="p-2 px-lg-3 mb-4 text-center left-for-free-shipping" v-if="missing_for_free_shipping > 0">
                       <span v-if="lang == 'it'">
                           Sei a € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} dalla spedizione gratuita.
                       </span>
                        <span v-else>
                           € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} left for free shipping.
                       </span>
                    </p>

                    <div class="subtotale d-flex pb-2">
                        <div class="flex-grow-1">{{$root.translateString('subtotal')}}</div>
                        <div class="">
                            € {{ $root.currencyDisplaySimple(priceTotalWt) }}
                        </div>
                    </div>
                    <div class="spedizione d-flex pb-4" v-if="should_be_shipped">
                        <div class="flex-grow-1">{{$root.translateString('shipping')}}</div>
                        <div class="">
                            <span v-if="shipping > 0">
                                 € {{ $root.currencyDisplaySimple(shipping) }}
                            </span>
                            <span v-else>{{$root.translateString('free')}}</span>
                        </div>

                    </div>
                    <div class="spedizione d-flex pb-4" v-if="discount > 0">
                        <div class="flex-grow-1">{{$root.translateString('discount')}}</div>
                        <div class="">
                            € {{ $root.currencyDisplaySimple(discount) }}
                        </div>
                    </div>
                    <div class="totale d-flex py-3 text-bigger">
                        <div class="d-flex flex-grow-1 flex-column">
                            <div class="">{{$root.translateString('total')}}</div>
                            <small class="mt-n1 text-gold">{{$root.translateString('tax_included')}}</small>
                        </div>
                        <div class="total-price"> € {{ $root.currencyDisplaySimple(finalPrice) }} </div>
                    </div>
                    <div class="text-center w-100 mt-4 pt-2 mb-2">
                        <div class="brand-btn">
                            <a class="full w-100" :href="$root.langRoute('/carrello')" >
                                <span>{{$root.translateString('go_to_cart')}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="background-obfuscator" @click="show = false"></div>
    </nav>
</template>
<script>
export default {
    props: ['lang'],
    data() {
        return {
            show:false,
            cartRaw: null,
            should_be_shipped: false,
            priceTotalWt: 0,
            finalPrice: 0,
            shipping: 0,
            discount: 0,
            missing_for_free_shipping: 0,
        }
    },
    mounted() {
        this.getCart();

        this.$eventHub.$on('cart.show', payload => {
            this.show = true;
        });

        this.$eventHub.$on('cart.added', payload => {
            this.getCart();
        });

        this.$eventHub.$on('cart.updated', payload => {
            this.getCart();
        });

    },
    methods: {
        translateVisitOptional(str) {
            if(this.lang == 'en' && str.indexOf('tagliere') > -1) {
                if(str.indexOf('pax') > -1) {
                    return str.split(' - ')[0] + ' - cold cuts included';
                }else{
                    return str.split(' - ')[0] + ' - without cold cuts';
                }
            }
            return str
        },
        emptyCart() {
            axios.post('/api/cart/empty', {})
            .then(response => {
                this.cartRaw = null;
                this.shipping = 0;
                this.priceTotalWt = 0;
                this.finalPrice = 0;
                this.discount = 0;
                this.missing_for_free_shipping = 0;
            })
        },
        updateCart(key, value) {

            axios.post('/api/cart/update', {
                'key': key,
                'qty': value,
            })
            .then(response => {
                this.getCart();

                let update_type = 'add';
                let quantity_to_track = value;

                if(quantity_to_track == 0) {

                    quantity_to_track = this.cart[key].qty;

                    /*gtag('event', 'remove_from_cart', {
                        "items": [
                            {
                                'name': this.cart[key].options.name,
                                'id': this.cart[key].id,
                                'price': this.cart[key].options.price,
                                'brand': 'Cantina Roeno',
                                'category': this.cart[key].options.type,
                                'variant': this.cart[key].options.combination.toLowerCase(),
                                'quantity': quantity_to_track
                            }
                        ]
                    });*/


                }else{

                    /*gtag('event', 'add_to_cart', {
                        "items": [
                            {
                                'name': this.cart[key].name,
                                'id': this.cart[key].id,
                                'price': this.cart[key].options.price,
                                'brand': 'Cantina Roeno',
                                'category': this.cart[key].options.type,
                                'variant': this.cart[key].options.combination.toLowerCase(),
                                'quantity': quantity_to_track
                            }
                        ]
                    });*/

                }

                this.$eventHub.$emit('cart.updated');
                this.$eventHub.$emit('cart.updated.simpleQty', parseInt(response.data.count));
            })
        },
        getCart() {
            axios.get('/api/cart/get')
            .then(response => {
                this.cartRaw = response.data.cart;
                this.shipping = response.data.shipping;
                this.priceTotalWt = response.data.priceTotalWt;
                this.finalPrice = response.data.finalPrice;
                this.discount = response.data.discount;
                this.should_be_shipped = response.data.shouldBeShipped;
                this.missing_for_free_shipping = response.data.missingForFreeShipping;

                if(_.isEmpty(this.cart)) {
                    this.show = false;
                }

            })
        },
        isNotEmpty(object) {
            return (_.isEmpty(object) === false);
        }
    },
    beforeDestroy() {
        this.$eventHub.$off('cart.added');
        this.$eventHub.$off('cart.show');
        this.$eventHub.$off('cart.updated');
        this.$eventHub.$off('cart.updated.simpleQty');
    },
    computed: {
        cart() {
            if(this.cartRaw == null) {
                return null;
            }

            let tmp = {};
            for (const [key, value] of Object.entries(this.cartRaw)) {
                if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                    tmp[key] = value;
                }
            }

            return tmp;
        },
        countProducts() {

            if(!this.isNotEmpty(this.cart)) {
                return 0;
            }

            let count = 0;

            for (let [key, item] of Object.entries(this.cart)) {
                count += item.qty;
            };

            return count;
        }
    }
}
</script>
